import { Injectable } from '@angular/core';
import { EssDeviceDto } from './ess-device.dto';
import { PghUserDeviceBase } from '../device/pgh-user-device';

@Injectable({
  providedIn: 'root'
})
export class DeviceAutoCompleteMfeService {

  public constructor() { }

  public buildPghUserDeviceFromEssDevice(essDevice: EssDeviceDto): PghUserDeviceBase {
    return {
      deviceTypeCode: essDevice.Attributes?.DeviceTypeCode,
      deviceTypeName: essDevice.Attributes?.DeviceType,
      displayName: essDevice.Description,
      make: essDevice.Manufacturer,
      model: essDevice.MarketingName,
      modelIdentifier: essDevice.ModelIdentifier,
    };
  }
}
